import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateDirect = ({
  directID,
  directName,
  mainBuyerId,
  refNumber,
  description,
  moreInfoURL,
  postingDate,
  startDate,
  lastOfferDate,
  endDate,
  value,
  additionalPeriods,
  competenceAreas,
}) =>
  axios.put(
    `/api/directs/${directID}`,
    JSON.stringify({
      direct_name: directName,
      ref_number: refNumber,
      Description: description,
      more_info_url: moreInfoURL,
      main_buyer_id: mainBuyerId,
      posting_date: postingDate,
      last_offer_date: lastOfferDate,
      start_date: startDate,
      end_date: endDate,
      value: value,
      additional_periods: additionalPeriods,
      competence_areas: competenceAreas,
    })
  );

export const useUpdateDirect = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateDirect,
    onSuccess: () => {
      enqueueSnackbar('Direct was succesfully updated', {
        variant: 'success',
      });

      refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
